var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('label',{staticClass:"field-group",class:{ 'field-group-error': !_setup.lazyIsValid },attrs:{"data-message":_setup.getMessage,"data-valid":_setup.isValid}},[_vm._t("default",null,{"valid":_setup.isValid})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }